theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.ajaxEnabled = $container.data('ajax-enabled');
   
    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      removeLineItem: '[data-remove-line-item]',
      changeLiQty: '[data-cart-popup-qty]',
      addGiftWrapLI: '[data-add-gwusli]',
      addToCartPopupUpsell: '[data-add-to-cart-upsell]',
      knoopifierAddToCart: '[data-knoopifier-add-to-cart]',
      knoopBundleAddToCart: '[data-bundle-add-to-cart]',
      kpPercentageSelect: '.kp-percentage-select .kbs-icon',
      knoopBundleSelect: '.knoops-bundle-select',
      knoopBundleGPSelect: '.knoops-bundle-gp-select',
      kpBundle: '.kp-bundle',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb'
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartUpsell = $(this.selectors.addToCartUpsell, $container);
    this.$addGiftWrapLI = $(this.selectors.addGiftWrapLI, $container);
    this.$removeLineItem = $(this.selectors.removeLineItem, $container)
    this.$knoopifierAddToCart = $(this.selectors.knoopifierAddToCart, $container);
    this.$knoopBundleAddToCart = $(this.selectors.knoopBundleAddToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );
    this.$productPolicies = $(this.selectors.productPolicies, $container);

    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }
    
    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );


    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._initRemoveLineItem();  
    this._initChangeLiQty();
    this._initaddGiftWrapLI();
    this._initKnoopifierAddToCart();
    this._initKnoopBundleAddToCart();
    this._initaddToCartPopupUpsell();
    this._setActiveThumbnail();
   	this._initCheckBundleSelect();
    
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        knoopBundleSelect: this.selectors.knoopBundleSelect,
        knoopBundleGPSelect: this.selectors.knoopBundleGPSelect,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      
      this.$container.on(
        'bundlePriceChange' + this.settings.namespace,
      	this._updatePrice.bind(this)
      );
      
      
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      $(this.selectors.productForm, this.$container).on(
        'submit',
        function(evt) {
          if (this.$addToCart.is('[aria-disabled]')) {
            evt.preventDefault();
            return;
          }
          
          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $(this.selectors.productForm, this.$container);
            this._addItemToCart($data);
            return;
          }
        }.bind(this)
      );
    },
   
    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initKnoopifierAddToCart: function() {
      $( this.$container).on(
        'click', this.selectors.knoopifierAddToCart,
        function(evt) {
          
          
          
          if (this.$knoopifierAddToCart.is('[aria-disabled]')) {
            evt.preventDefault();
            return;
          }
		  
          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $kbIcon = $(this.selectors.kpPercentageSelect, this.$container);
            
            var $data = $(this.selectors.productForm, this.$container).serializeArray();
            var $items = {items:[]};
            
            var form_object = {};

            $($data).each( function( i,v ){
                form_object[v.name] = v.value;
            });
            form_object['properties[packID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
            form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
            
            $items.items.push( form_object );
			
            if( typeof $kbIcon[0] !== 'undefined' && typeof $($kbIcon).data('variant-id') !== 'undefined' ){
              var new_form_object = {};
              $( $data ).each( function( i,v ){
                  new_form_object[v.name] = v.value;
              });
              new_form_object.id = $($kbIcon).data('variant-id');
              new_form_object['properties[packID]'] = form_object['properties[packID]'];
              new_form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
              $items.items.push( new_form_object );
            }
            /* Do any bundle stuff here */
                       
            var $kbBundle = $(this.selectors.kpBundle, this.$container);
            if( typeof $kbBundle[0] !== 'undefined' && typeof $($kbBundle).data('variant-id') !== 'undefined' ){
              var bundle_form_object = {};
              $( $data ).each( function( i,v ){
                  bundle_form_object[v.name] = v.value;
              });
              bundle_form_object.id = $($kbBundle).data('variant-id');
              bundle_form_object['properties[packID]'] = form_object['properties[packID]'];
              bundle_form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
              $items.items.push( bundle_form_object );              
            }
			/* End */            

            this._knoopifierAddToCart($items);
            return;
          }
        }.bind(this)
      );
    },

    _initCheckBundleSelect: function(){
       var $kbIcon = $(this.selectors.knoopBundleSelect, this.$container);
       this._bundleAddToCartButtonEnable($kbIcon);
      
       $(this.$container).on('change', $kbIcon, function( evt ){
         this._bundleAddToCartButtonEnable($kbIcon);
       }.bind( this ) );  
    },
    
    _bundleAddToCartButtonEnable: function($kbIcon){
      	//console.log(jQuery($kbIcon).val());
         if( jQuery($kbIcon).val() !== null ){
           this.$knoopBundleAddToCart.removeAttr('aria-disabled');
         }else{
           this.$knoopBundleAddToCart.attr('aria-disabled', true);
         }    	
    },
    
    _initKnoopBundleAddToCart: function() {
      
      $( this.$container).on(
        'click', this.selectors.knoopBundleAddToCart,
        function(evt) {
          
          
          
          if (this.$knoopBundleAddToCart.is('[aria-disabled]')) {
            evt.preventDefault();
            return;
          }
		  
          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $kbIcon = $(this.selectors.knoopBundleSelect, this.$container);
            
            var $data = $(this.selectors.productForm, this.$container).serializeArray();
            var $items = {items:[]};
            
            var form_object = {};
			
            var $kpGPIcon = $(this.selectors.knoopBundleGPSelect, this.$container);
			
            
            $($data).each( function( i,v ){
                form_object[v.name] = v.value;
            });
            form_object['properties[packID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
            form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
            
            $items.items.push( form_object );
			
            if( typeof $kbIcon[0] !== 'undefined' && typeof $($kbIcon).val() !== 'undefined' ){

              var new_form_object = {};
              $( $data ).each( function( i,v ){
                  new_form_object[v.name] = v.value;
              });
              new_form_object.id = $($kbIcon).val();
              new_form_object['properties[packID]'] = form_object['properties[packID]'];
              new_form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
              $items.items.push( new_form_object );
            }else{
              

            }
            
            /* Do any gppackagin */
            
            if( typeof $kpGPIcon[0] !== 'undefined' && typeof $($kpGPIcon).val() !== 'undefined' && $($kpGPIcon).val() !== '' ){
              var gp_form_obj = {};
              $( $data ).each( function( i,v ){
                  gp_form_obj[v.name] = v.value;
              });              
              gp_form_obj.id = $($kpGPIcon).val();
              //new_form_object['properties[packID]'] = form_object['properties[packID]'];
              //new_form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
              $items.items.push( gp_form_obj );              
            }
            
            /* Do any bundle stuff here */
                       
            var $kbBundle = $(this.selectors.kpBundle, this.$container);
            if( typeof $kbBundle[0] !== 'undefined' && typeof $($kbBundle).data('variant-id') !== 'undefined' ){
              var bundle_form_object = {};
              $( $data ).each( function( i,v ){
                  bundle_form_object[v.name] = v.value;
              });
              bundle_form_object.id = $($kbBundle).data('variant-id');
              bundle_form_object['properties[packID]'] = form_object['properties[packID]'];
              bundle_form_object['properties[packetID]'] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);       	
              $items.items.push( bundle_form_object );              
            }
			/* End */            

            this._knoopifierAddToCart($items);
            return;
          }
        }.bind(this)
      );
    },    
    
    _addItemToCart: function(data) {
      
      var params = {
        url: '/cart/add.js',
        data: $(data).serialize(),
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(item) {
            this._hideErrorMessage();
            this._setupCartPopup(item);
          }.bind(this)
        )
        .fail(
          function(response) {
            console.log( data );
            this.$previouslyFocusedElement.focus();
            var errorMessage = response.responseJSON
              ? response.responseJSON.description
              : theme.strings.cartError;
            this._showErrorMessage(errorMessage);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );
    },
    _initRemoveLineItem: function(){
       let themeObj = this; 
      $(document).on( 'click', themeObj.selectors.removeLineItem, function(e){
          
          let data = [];
          if( typeof $(this).data('cart-item-key') == 'undefined' ){
            return false;
          }

          if( typeof $(this).data('cart-item-key') == 'string' && $(this).data('cart-item-key').indexOf(',') >= 0 ){
            let cartIndex = $(this).data('cart-item-key');
            cartIndex.split(',').forEach( ind => data.push( ind ) );
          }else{
            data.push( $(this).data('cart-item-key') );
          }
          themeObj._removeLineItem( data, $(this), e );
      });
    },
    _removeLineItem: function( data, element, event ){
      const cartURL = '/cart/update.js';
      let cartdata = {'updates': {} };
      data.forEach((item) => {
          cartdata.updates[item] = 0;
      });
      let themeObj = this;
      element.find('.lds-ring').removeClass('hide');
      fetch(cartURL, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(cartdata)
      }).then( (response) => response.json() ).then( (data) => { if( data.item_count <= 0 ){ themeObj._hideCartPopup(event) } element.find('.lds-ring').addClass('hide'); themeObj._softUpdateCartPopup(data); } ).catch( (error) => { 
          themeObj._showErrorMessage( error ); 
          element.find('.lds-ring').addClass('hide');
      } );  
    },
    _initChangeLiQty: function(){
         let themeObj = this; 
          $(document).on( 'blur', themeObj.selectors.changeLiQty, function(e){
            if( $(this).val() === $(this).data('original-value') ){
              return false;
            } 
            let lds = $(this).closest('.cart-popup-item__quantity').find('.lds-ring');
            let data = {}; 
            data[$(this).data('cart-item-key')] = $(this).val();
            themeObj._changeLiQty(data,lds,e);
          });    
    },
    _changeLiQty: function( data, lds, event ){
      const cartURL = '/cart/update.js';
      let cartdata = {'updates': data };
      let themeObj = this;
      lds.removeClass('hide'); 
      fetch(cartURL, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(cartdata)
      }).then( (response) => response.json() ).then( (data) => { if( data.item_count <= 0 ){ themeObj._hideCartPopup(event) } lds.addClass('hide'); themeObj._softUpdateCartPopup(data); } ).catch( (error) => { 
          themeObj._showErrorMessage( error ); 
          lds.addClass('hide');
      } );
      
    },

    _initaddToCartPopupUpsell: function(){
      let themeObj = this;
      $(document).on( 'click', themeObj.selectors.addToCartPopupUpsell, function(e){
        if( typeof $(this).data('add-to-cart-variantid') === 'undefined'){
          return false;
        }
        if( typeof $(this).data('add-to-cart-qty') === 'undefined'){
          return false;
        }
        let data = [{'id': $(this).data('add-to-cart-variantid'), 'quantity': $(this).data('add-to-cart-qty') }];
        let spinner = $(this).find('[data-loader]');

        themeObj._addToCartPopupUpsell( data, spinner, e );
      } );
    },
    
    _addToCartPopupUpsell: function( data, spinner, event ){
        let cartdata = { "items": data };
        console.log( cartdata );
        const cartURL = '/cart/add.js';
        let themeObj = this;
        spinner.removeClass('hide');
        fetch(cartURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(cartdata)
        }).then( (response) => response.json() ).then( (data) => { if( data.item_count <= 0 ){ themeObj._hideCartPopup(event) } spinner.addClass('hide'); themeObj._softUpdateCartPopup(data); } ).catch( (error) => { 
            themeObj._showErrorMessage( error ); 
            spinner.addClass('hide');
        } );
        
    },
    _initaddGiftWrapLI: function(){
      let themeObj = this;
      $(document).on( 'click', themeObj.selectors.addGiftWrapLI, function(e){
        let qty = $(this).closest('.gift-sleeve-upsell').find('.quantity').val();
        let variantID = $(this).closest('.gift-sleeve-upsell').find('.first_variant_id').val();    
        let spinner = $(this).closest('.gift-sleeve-upsell').find('.lds-ring');
        let data = [{'id': variantID, 'quantity': qty }];
        themeObj._addToCartPopupUpsell( data, spinner, e ); 
      });
    },
    _knoopifierAddToCart: function( data ){
       var params = {
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      };

      $.post(params)
        .done(
        
          function(item) {
				window.location = '/cart';
          }.bind(this)
        )
        .fail(
          function(response) {
            this.$previouslyFocusedElement.focus();
            var errorMessage = response.responseJSON
              ? response.responseJSON.description
              : theme.strings.cartError;
            this._showErrorMessage(errorMessage);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );  		
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.$addToCart.attr('aria-disabled', true);
        this.$knoopBundleAddToCart.attr('aria-disabled', true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr('disabled', true);
        this.$loaderStatus.attr('aria-hidden', false);
      } else {
        this.$addToCart.removeAttr('aria-disabled');
        this.$knoopBundleAddToCart.attr('aria-disabled', true);        
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr('disabled');
        this.$loaderStatus.attr('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr('aria-hidden', true)
        .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
      this.$cartPopupWrapper =
        this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
      this.$cartPopupTitle =
        this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
      this.$cartPopupQuantity =
        this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
      this.$cartPopupQuantityLabel =
        this.$cartPopupQuantityLabel ||
        $(this.selectors.cartPopupQuantityLabel);
      this.$cartPopupClose =
        this.$cartPopupClose || $(this.selectors.cartPopupClose);
      this.$cartPopupDismiss =
        this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
      this.$cartPopupImagePlaceholder =
        this.$cartPopupImagePlaceholder ||
        $(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace('[count]', quantity)
      );

      this._setCartPopupPlaceholder(
        item.featured_image.url,
        item.featured_image.aspect_ratio
      );
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      $.getJSON('/cart.js').then(
        function(cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
          
        }.bind(this)
      );
      document.getElementById('cart-popup').dispatchEvent( new Event( 'updateContent' ) );
    },
    _softUpdateCartPopup: function(cart){
        if (typeof cart.item_count === 'undefined' ){ 
          document.getElementById('cart-popup').dispatchEvent( new Event( 'updateContent' ) ); 
          $.getJSON('/cart.js').then(
            function(cart) {
              this._setCartQuantity(cart.item_count);
              this._setCartCountBubble(cart.item_count);            
            }.bind(this)
          );        
        }else{
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          document.getElementById('cart-popup').dispatchEvent( new Event( 'updateContent' ) );
        }
    },
    _setupCartPopupEventListeners: function() {
      this.$cartPopupWrapper.on(
        'keyup',
        function(event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
      $('body').on('click', this._onBodyClick.bind(this));
    },

    _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
      var maxWidth = 95 * imageAspectRatio;
      var heightRatio = 100 / imageAspectRatio;

      this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

      $placeholder.css('padding-top', heightRatio + '%');
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.dataset.cartPopupImage = '';

      image.onload = function() {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html('');
        this.$cartPopupProductDetails.attr('hidden', '');
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption.name +
          ': ' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _setCartQuantity: function(quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function() {
      this.$cartPopupWrapper
        .prepareTransition()
        .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
        .prepareTransition()
        .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off('keyup');
      this.$cartPopupClose.off('click');
      this.$cartPopupDismiss.off('click');
      //$('body').off('click');
    },

    _onBodyClick: function(event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 5,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

       $(this.selectors.productThumbs).slick(options);


      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr('aria-disabled')
            .attr('aria-label', theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          this.$shopifyPaymentButton.show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          this.$addToCart
            .attr('aria-disabled', true)
            .attr('aria-label', theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          this.$shopifyPaymentButton.hide();
        }
      } else {
        this.$addToCart
          .attr('aria-disabled', true)
          .attr('aria-label', theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        this.$shopifyPaymentButton.hide();
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;
      
      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeClass(this.classes.productUnitAvailable)
        .removeClass(this.classes.productSoldOut)
        .removeAttr('aria-hidden');

      this.$productPolicies.removeClass(this.classes.visibilityHidden);

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);

        this.$productPolicies.addClass(this.classes.visibilityHidden);
        return;
      }

      // Sold out
      if (!variant.available) {
        $priceContainer.addClass(this.classes.productSoldOut);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Unit price
      if (variant.unit_price) {
        $unitPrice.html(
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
        );
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var $limit = 3;
    
    if( typeof knoopsProductRecommendationsObject !== 'undefined' &&  knoopsProductRecommendationsObject.limit !== 'undefined' ){
    	var $limit = 12;/* Previously tried dynamic but Shopify renders the tag a few times - this ensures there are more products to loop through */
    }
    
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit='+$limit;

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this)
    );
  }

  return ProductRecommendations;
})();

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('product', theme.Product);
  sections.register('product-card', theme.Product);  
  sections.register('product-template', theme.Product);
  sections.register('product-recommendations', theme.ProductRecommendations);
});

$(document).ready(function(){
  function update_bundle_price(){
    if( typeof $('.knoops-bundle-select')[0] !== 'undefined' ){
    var bundle_item = $('.knoops-bundle-select');
    var closestForm = $(bundle_item).closest('form');
    var main_item = $(closestForm).find('select[name="id"]');
    var main_price = $(main_item).find('option[value="'+$(main_item).val()+'"]').data('price');
    
    var running_cost = main_price;
    $( bundle_item ).each(function(){
      if( $(this).val() !== null && $(this).val() !== '' ){
        var bundle_price = $(this).find('option[value="'+$(this).val()+'"]').data('price');
        
        running_cost += bundle_price;
      }  
    });
    
    var new_total = theme.Currency.formatMoney(
      running_cost,
      theme.moneyFormat
    ); 
    
    $('.product-single [data-regular-price]').html( new_total );
    
    }
  }
  
  update_bundle_price();
  $('body').on('change', '.single-option-selector, .knoops-bundle-select', function(){
  	update_bundle_price();
  });
  
});